/**
 * Page-config-id's van de Human Design-pagina's die programmatic aangeroepen
 * worden (via EgiPageNavigationService); één bron voor de route-registratie in
 * hd.pages.module en de callers.
 */
export const HD_CHART_ENVIRONMENT_PAGE_ID = 'e7a9c1d2-3b45-4c6d-8e9f-0a1b2c3d4e5f';
export const HD_LIFE_TIMELINE_PAGE_ID = 'c5e8a2f4-6d19-4b73-9a58-2f4c8e1d7b36';
/**
 * Tweede registratie van dezelfde tijdlijn-component, maar als dóórklikpagina
 * (isClickThroughPage) onder de chart-omgeving: het beheer biedt alleen
 * pagina's mét dat vlaggetje aan als doorklik-kind, en het vlaggetje haalt ze
 * juist uit de gewone menulijst — vandaar twee registraties (patroon
 * digi-website, bv. artikel-fiche).
 */
export const HD_LIFE_TIMELINE_CLICKTHROUGH_PAGE_ID = 'a9d3c7e1-2f58-4b64-8c17-5e9a3d6f2b84';
/**
 * Ephemeris-pagina (poort/lijn-wissels in tabelvorm, spec 2026-10-13). Ook het
 * doelwit voor de toekomstige "chart met de hand uitrekenen"-tutorial.
 */
export const HD_EPHEMERIS_PAGE_ID = '6579c2b5-7088-45db-a29a-5d55481dc43a';
/**
 * Classic I Ching-raadpleegpagina (spec 2026-10-18). Het menu-item wordt via
 * UPAM-beheer aangemaakt; de pagina controleert zelf feature + setting.
 */
export const HD_CLASSIC_ICHING_PAGE_ID = '3f6b1a2c-9d4e-4f7a-8b5c-2e1d0c9a8b7f';
